import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCheck,
  faCheckDouble,
  faFilePdf,
  faImage,
  faMicrophone,
  faUser,
  faUserMd,
} from "@fortawesome/free-solid-svg-icons";
//import DrAvatar from "../../assets/DrAvatar.png";
import UserAvatar from "../../assets/UserImage.png";
import "./ChatItem.css";
import { getDecodedUserId } from "../../Services/GeneralService";
import { resolveMediaUrl } from "../../utils/seo";

const ChatItem = (props) => {
  const userId = getDecodedUserId();
  const { isFromUser, session, handleJoinChat, drImgSrc, footer } = props;
  const {
    id,
    doctorName,
    patientName,
    lastMessageSenderId,
    lastMessageIsRead,
    lastMessageType,
    lastMessageText,
    lastMessageTime,
    unreadMessagesCount,
  } = session;

  const isPhoto = lastMessageType === "photo";
  const isFile = lastMessageType === "file";
  const isAudio = lastMessageType === "audio";

  const getRelativeTime = (time) => {
    if (!time) return "";
    const now = new Date();
    const messageDate = new Date(time);
    const diffMs = now - messageDate;
    const diffSec = Math.floor(diffMs / 1000);
    const diffMin = Math.floor(diffSec / 60);
    const diffHr = Math.floor(diffMin / 60);
    const diffDay = Math.floor(diffHr / 24);
    const diffMonths = Math.floor(diffDay / 30);
    const diffYears = Math.floor(diffDay / 365);

    if (diffSec < 60) return "همین الان";
    if (diffMin < 60) return `${diffMin} دقیقه قبل`;
    if (diffHr < 24) return `${diffHr} ساعت قبل`;
    if (diffDay < 30) return `${diffDay} روز قبل`;
    if (diffMonths < 12) return `${diffMonths} ماه قبل`;
    if (diffYears >= 1 && diffDay < 20) return `${diffYears} سال قبل`;
    return "";
  };

  const renderMessageType = () => {
    if (isPhoto) {
      return (
        <span className="message-type-indicator">
          <FontAwesomeIcon icon={faImage} />
          <span>عکس</span>
        </span>
      );
    }
    if (isFile) {
      return (
        <span className="message-type-indicator">
          <FontAwesomeIcon icon={faFilePdf} />
          <span>فایل</span>
        </span>
      );
    }
    if (isAudio) {
      return (
        <span className="message-type-indicator">
          <FontAwesomeIcon icon={faMicrophone} />
          <span>پیام صوتی</span>
        </span>
      );
    }
    return lastMessageText;
  };

  const renderReadStatus = () => {
    if (lastMessageSenderId !== userId) return null;

    return (
      <span className={`read-status ${lastMessageIsRead ? "read" : "unread"}`}>
        <FontAwesomeIcon icon={lastMessageIsRead ? faCheckDouble : faCheck} />
      </span>
    );
  };

  return (
    <>
      <div
        className={`chat-item ${unreadMessagesCount > 0 ? "has-unread" : ""}`}
      >
        <div className="chat-item-main" role="button" tabIndex={0}
          aria-label={`مشاهده مشاوره با ${isFromUser ? `دکتر ${doctorName}` : patientName}`}
          onClick={() => handleJoinChat(id)} onKeyDown={(event) => {
            if (event.key === "Enter" || event.key === " ") { event.preventDefault(); handleJoinChat(id); }
          }}>
        <div className="avatar-container">
          <img
            src={isFromUser ? resolveMediaUrl(drImgSrc) : UserAvatar}
            alt={isFromUser ? "Doctor" : "Patient"}
            className="avatar"
          />
          <div className="avatar-badge">
            <FontAwesomeIcon icon={isFromUser ? faUserMd : faUser} />
          </div>
        </div>

        <div className="chat-content">
          <div className="chat-header">
            <div className="chat-name">
              {isFromUser ? `دکتر ${doctorName}` : patientName}
            </div>
            <div className="chat-time">{getRelativeTime(lastMessageTime)}</div>
          </div>

          <div
            className={`chat-message ${
              unreadMessagesCount > 0 ? "unread" : ""
            }`}
          >
            {renderReadStatus()}
            <span className="message-text">{renderMessageType()}</span>
            {unreadMessagesCount > 0 && (
              <div className="unread-badge">{unreadMessagesCount}</div>
            )}
          </div>
        </div>
        </div>
        {footer}
      </div>
    </>
  );
};

export default ChatItem;
